<script>
import api from "../api/api"

export default {
  name: "OptionsFieldsMixin",
  methods: {
    /**
     * Based on options request this method is creating
     * @returns {Promise<*[]>}
     */
    async getFields() {
      let response = await api.options(`/${this.url}/`)
      let config = response.data.actions.POST
      let tempFields = []
      // To make sure the 'name' is used as a key in the object rather then the key of the whole object
      for (const property in config) {
        let field = config[property]
        if (this.formOrder.includes(property)) {
          field['name'] = property
          tempFields.push(field)
        }
      }
      this.orderForm(tempFields)
    },
    orderForm(fields) {
      if (this.formOrder) {
        this.formOrder.forEach(fieldName => fields.forEach(field => {
          if (fieldName === field['name']) {
            this.fields.push(field)
          }
        }))
      }
    },
  }
}
</script>

<style scoped>

</style>